import React from 'react';
import { ButtonStandard } from '@src/components/Button';
import { COLOR_LIME, ButtonColors } from '@src/types/colors';
import { ButtonIconPosition, ButtonSize } from '@src/types/buttons';
import BoxIcon from '@src/elements/BoxIcon';
import styles from '@src/components/Header/EnquireButton/EnquireButton.module.scss';
import { useRouter } from 'next/router';
import { useViewport } from '@src/hooks/useViewport';
import classNames from 'classnames';
import { handleEnquireButtonScrollToClick } from '@src/utils/scrollToEnquireForm';

interface EnquireButton {
  scrollToId: string;
  handleCloseMobileMenu?: (event: React.MouseEvent) => void;
  testid: string;
  size?: ButtonSize;
  buttonText?: string;
  color?: ButtonColors;
  iconPosition?: ButtonIconPosition;
}

const EnquireButton: React.FC<EnquireButton> = ({
  scrollToId,
  handleCloseMobileMenu,
  testid,
  size = 'md',
  buttonText = 'Enquire now',
  color = COLOR_LIME,
  iconPosition = 'right'
}) => {
  const router = useRouter();
  const { width } = useViewport();

  return (
    <ButtonStandard
      data-testid={testid}
      color={color}
      aria-label="Enquire"
      size={size}
      onClick={(event) =>
        handleEnquireButtonScrollToClick(
          width,
          router,
          event,
          handleCloseMobileMenu,
          scrollToId
        )
      }
      className={classNames(styles.enquireButton, {
        [styles.enquireButtonIconLeft]: iconPosition === 'left'
      })}
    >
      {buttonText}
      {/* TODO: move to ButtonStandard "icon" prop once that's switched to BoxIcon */}
      <BoxIcon name="edit-alt" size="sm" />
    </ButtonStandard>
  );
};

export default EnquireButton;
